// apps/patient/src/pages/SubscribeRequired.tsx
//
// Landing page for standalone Ready2Exercise users whose subscription is not active
// (expired trial, cancelled, or past due). ProtectedRoute redirects here; Profile stays reachable.

import { useNavigate } from 'react-router-dom';
import { usePatient } from '../contexts/PatientContext';
import { PageHeader } from '../components/layout/PageHeader';
import { SubscriptionSection } from '../components/profile/SubscriptionSection';

export function SubscribeRequired() {
  const navigate = useNavigate();
  const { patient: user } = usePatient();

  if (!user) return null;

  return (
    <div className="max-w-2xl mx-auto p-4 md:p-6 lg:p-8">
      <PageHeader title="Subscription needed" />
      <p className="mt-4 text-gray-600">
        Your Ready2Exercise subscription is not active. Subscribe to get back to your workouts, or
        update your card if a payment failed.
      </p>
      <div className="mt-6 bg-white rounded-lg shadow-sm">
        <SubscriptionSection
          user={user}
          returnPath="/subscribe"
          title="Ready2Exercise"
          onConfirmed={() => navigate('/programs', { replace: true })}
        />
      </div>
    </div>
  );
}
